// const WRGGHomeLogo = ({ className = "h-60 w-60" }) => (

//   <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
//     {/* <!-- Rounded rectangle border --> */}
//     {/* <rect x="10" y="10" width="180" height="180" rx="20" ry="20"
//       fill="none"
//       stroke="white"
//       stroke-width="12" /> */}

//     {/* <!-- Diagonal line (slightly more vertical) --> */}
//     <line x1="70" y1="170" x2="130" y2="30"
//       stroke="white"
//       stroke-width="14"
//       stroke-linecap="round" />

//     {/* <!-- Top circle - smaller and higher --> */}
//     <circle cx="65" cy="50" r="18"
//       fill="none"
//       stroke="white"
//       stroke-width="14" />

//     {/* <!-- "W" - custom rounded shape, centered --> */}
//     <path d="M 53 92 L 59 112 L 65 98 L 71 112 L 77 92"
//       stroke="#0891b2"
//       stroke-width="8"
//       stroke-linecap="round"
//       stroke-linejoin="round"
//       fill="none" />

//     {/* <!-- Bottom circle - moved up for symmetry --> */}
//     <circle cx="135" cy="150" r="18"
//       fill="none"
//       stroke="white"
//       stroke-width="14" />

//     {/* <!-- "R" - custom rounded shape with open bowl --> */}
//     <g transform="translate(125, 92)">
//       {/* <!-- Vertical stem of R --> */}
//       <line x1="0" y1="0" x2="0" y2="20"
//         stroke="#0891b2"
//         stroke-width="8"
//         stroke-linecap="round" />

//       {/* <!-- Top curve of R - more open --> */}
//       <path d="M 0 0 L 10 0 Q 16 0 16 5 Q 16 10 10 10 L 0 10"
//         stroke="#0891b2"
//         stroke-width="8"
//         stroke-linecap="round"
//         stroke-linejoin="round"
//         fill="none" />

//       {/* <!-- Leg of R --> */}
//       <line x1="8" y1="10" x2="16" y2="20"
//         stroke="#0891b2"
//         stroke-width="8"
//         stroke-linecap="round" />
//     </g>
//   </svg>
// );

// export default WRGGHomeLogo;

const WRGGHomeLogo = ({ className = "block h-32 w-auto" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="16 18 590 252" role="img" aria-label="WIN logo" className={className}>
      <defs>
        <linearGradient id="ringGrad" x1="135" y1="55" x2="330" y2="235" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#45D7FF" />
          <stop offset="100%" stopColor="#2FA8FF" />
        </linearGradient>
        <linearGradient id="cursorGrad" x1="35" y1="80" x2="250" y2="205" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#86F5F2" />
          <stop offset="100%" stopColor="#35B6FF" />
        </linearGradient>

        <mask id="ringCut">
          <rect width="100%" height="100%" fill="white" />
          <path d="M72 90 L162 120 L162 170 L72 200 L72 156 L118 145 L72 134 Z" fill="black" />
          <path d="M97 122 L169 146 L97 170 L130 146 Z" fill="black" />
        </mask>

        <mask id="cursorHoleMask">
          <rect width="100%" height="100%" fill="white" />
          <path d="M97 122 L169 146 L97 170 L130 146 Z" fill="black" />
        </mask>
      </defs>

      <ellipse
        cx="230"
        cy="145"
        rx="78"   // narrower width
        ry="94"   // keep height the same
        fill="none"
        stroke="url(#ringGrad)"
        strokeWidth="20"
        mask="url(#ringCut)"
      />

      <path
        d="M35 69
     L261 146
     L35 229
     L76 149 Z"
        fill="url(#cursorGrad)"
        mask="url(#cursorHoleMask)"
        transform="translate(148 146) scale(0.94) translate(-148 -146)"
      />

      <text
        x="338"
        y="192"
        fill="#FFFFFF"
        fontFamily="'Rajdhani', 'Orbitron', 'Exo 2', 'Montserrat', sans-serif"
        fontSize="128"
        fontWeight="600"
        letterSpacing="2"
      >
        WIN
      </text>
    </svg>
);

  export default WRGGHomeLogo;
